import { render, staticRenderFns } from "./MobileBreadcrumb.vue?vue&type=template&id=1ffde285&scoped=true&"
import script from "./MobileBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MobileBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MobileBreadcrumb.vue?vue&type=style&index=0&id=1ffde285&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffde285",
  null
  
)

export default component.exports